// src/landing/AutoBackdrop.jsx
// ─── Univers automobile abstrait (§73-85) ───────────────────────────────────
// Ni photo, ni clipart. Des formes architecturales : une courbe de toit, deux
// arcs de passage de roue, une ligne de sol, un flux aérodynamique, et
// quelques points de « scan » évoquant la lecture de données.
//
// §77 — Il doit falloir quelques secondes pour comprendre qu'il s'agit d'une
// automobile. Les arcs ne sont pas fermés, la ligne de toit ne rejoint pas le
// sol : l'œil complète la forme lui-même. C'est ce qui sépare le premium du
// pictogramme.
//
// §85 — Rien de tout cela ne passe au-dessus du contenu : `pointer-events:none`
// et un z-index inférieur. §83 — l'animation s'arrête sous prefers-reduced-motion.

export function AutoBackdrop({ variant = "hero" }) {
  return (
    <div className={`viq-backdrop viq-backdrop-${variant}`} aria-hidden="true">
      {/* Gradients : gold chaud, graphite, vert VehicleIQ très discret (§75) */}
      <div className="viq-backdrop-glow" />
      <svg className="viq-backdrop-svg" viewBox="0 0 1440 620" preserveAspectRatio="xMidYMax slice" focusable="false">
        <defs>
          <linearGradient id="viqLine" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="currentColor" stopOpacity="0" />
            <stop offset="28%" stopColor="currentColor" stopOpacity="1" />
            <stop offset="72%" stopColor="currentColor" stopOpacity="1" />
            <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="viqTrail" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="currentColor" stopOpacity="0" />
            <stop offset="50%" stopColor="currentColor" stopOpacity=".9" />
            <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Ligne de sol */}
        <line x1="0" y1="520" x2="1440" y2="520" stroke="url(#viqLine)" strokeWidth="1.5" />

        {/* Courbe de toit — ouverte aux deux extrémités */}
        <path d="M300 470 C360 470 400 392 470 350 C560 296 700 272 830 288 C940 302 1030 350 1090 412 C1120 444 1140 468 1170 476"
          fill="none" stroke="url(#viqLine)" strokeWidth="2.5" strokeLinecap="round" />
        {/* Ligne de ceinture, parallèle et plus courte : profondeur sans dessin */}
        <path d="M380 452 C470 402 620 372 780 380 C900 386 1000 418 1060 460"
          fill="none" stroke="currentColor" strokeWidth="1.2" strokeOpacity=".55" strokeLinecap="round" />

        {/* Passages de roue : arcs seuls, jamais des cercles pleins */}
        <path d="M448 520 A62 62 0 0 1 572 520" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M868 520 A62 62 0 0 1 992 520" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        {/* Rappel de jante : trois rayons, pas une roue complète */}
        <g stroke="currentColor" strokeWidth="1" strokeOpacity=".45">
          <line x1="510" y1="520" x2="510" y2="472" /><line x1="510" y1="520" x2="470" y2="496" /><line x1="510" y1="520" x2="550" y2="496" />
          <line x1="930" y1="520" x2="930" y2="472" /><line x1="930" y1="520" x2="890" y2="496" /><line x1="930" y1="520" x2="970" y2="496" />
        </g>

        {/* Flux aérodynamique — c'est lui qui reçoit l'animation lente (§82) */}
        <g className="viq-backdrop-flow" stroke="url(#viqTrail)" strokeWidth="1.4" strokeLinecap="round" fill="none">
          <path d="M120 330 C260 306 400 300 520 306" />
          <path d="M90 372 C240 346 380 340 500 346" />
          <path d="M150 288 C280 268 400 264 500 268" />
        </g>

        {/* Traitement « data » : points de scan le long de la carrosserie (§78) */}
        <g className="viq-backdrop-scan" fill="currentColor">
          {[[470,352],[560,312],[660,290],[760,284],[860,296],[960,330],[1040,378]].map(([x,y],i)=>(
            <circle key={i} cx={x} cy={y} r="2.4" style={{ animationDelay: `${i * 0.4}s` }} />
          ))}
        </g>
        {/* Ligne de scan verticale, très lente */}
        <line className="viq-backdrop-scanline" x1="0" y1="240" x2="0" y2="520" stroke="currentColor" strokeWidth="1" />
      </svg>
    </div>
  );
}

export default AutoBackdrop;
